import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MultiModulePickerService {
  tabs= [];
  intialAssociatedModules: any;
  associatedModules = new Subject();
  defaultModule: string;
  notesPickerPreferences = {
    'JOB': {
      preference: {
        project: 'BOTH', customer: 'BOTH', organization: 'BOTH', property: 'BOTH', asset: 'BOTH', contract: 'BOTH', quote: 'BOTH', invoice: 'BOTH'
      },
      filter: 'filter.job',
      label: 'text.picker.accociation.linked.job'
    },
    'PROJECT': {
      preference: { job: 'BOTH', customer: 'BOTH', organization: 'BOTH', property: 'BOTH', asset: 'BOTH', contract: 'BOTH', quote: 'BOTH', invoice: 'BOTH' },
      filter: 'filter.project',
      label: 'text.picker.accociation.linked.project'
    },
    'CUSTOMER': {
      preference: { project: 'BOTH', job: 'BOTH', organization: 'BOTH', property: 'BOTH', asset: 'BOTH', contract: 'BOTH', quote: 'BOTH', invoice: 'BOTH' },
      filter: 'filter.customer',
      label: 'text.picker.accociation.linked.customer'
    },
    'ORGANIZATION': {
      preference: { project: 'BOTH', job: 'BOTH', customer: 'BOTH', property: 'BOTH', asset: 'BOTH', contract: 'BOTH', quote: 'BOTH', invoice: 'BOTH' },
      filter: 'filter.organization',
      label: 'text.picker.accociation.linked.organization'
    },
    'PROPERTY': {
      preference: { project: 'BOTH', job: 'BOTH', customer: 'BOTH', organization: 'BOTH', asset: 'BOTH', contract: 'BOTH', quote: 'BOTH', invoice: 'BOTH' },
      filter: 'filter.property',
      label: 'text.picker.accociation.linked.property'
    },
    'SERVICE_CONTRACTS': {
      preference: { project: 'BOTH', job: 'BOTH', customer: 'BOTH', organization: 'BOTH', asset: 'BOTH', property: 'BOTH', quote: 'BOTH', invoice: 'BOTH' },
      filter: 'filter.service_contract',
      label: 'text.picker.accociation.linked.contract'
    },
    'ASSETS': {
      preference: { project: 'BOTH', job: 'BOTH', customer: 'BOTH', organization: 'BOTH', contract: 'BOTH', property: 'BOTH', quote: 'ALL', invoice: 'ALL' },
      filter: 'filter.asset',
      label: 'text.picker.accociation.linked.asset'
    },
    'ESTIMATES': {
      preference: { project: 'BOTH', job: 'BOTH', customer: 'BOTH', organization: 'BOTH', contract: 'BOTH', property: 'BOTH', asset: 'ALL', invoice: 'BOTH' },
      filter: 'filter.quote',
      label: 'text.picker.accociation.linked.quote'
    },
    'INVOICE': {
      preference: { project: 'BOTH', job: 'BOTH', customer: 'BOTH', organization: 'BOTH', contract: 'BOTH', property: 'BOTH', asset: 'ALL', quote: 'BOTH' },
      filter: 'filter.invoice',
      label: 'text.picker.accociation.linked.invoice'
    },
    'PROPOSAL': {
      preference: { project: 'BOTH', job: 'BOTH', customer: 'BOTH', organization: 'BOTH', contract: 'BOTH', property: 'BOTH', asset: 'ALL', invoice: 'BOTH' },
      filter: 'filter.proposal',
      label: 'text.picker.accociation.linked.proposal'
    },
    'REQUEST': {
      preference: { project: 'ALL', job: 'LINKED', customer: 'BOTH', organization: 'BOTH', contract: 'BOTH', property: 'BOTH', asset: 'BOTH', invoice: 'BOTH', quote: 'BOTH' },
      filter: 'filter.request',
      label: 'text.picker.accociation.linked.request'
    }
  };

  constructor() { }

  setTabs(tabs): any{
    this.tabs = tabs;
  }
  getTabs(): any{
      return this.tabs;
  }
  setAssociatedModules(associatedModules): void{
    this.intialAssociatedModules = associatedModules;
  }
  getAssociatedModules(): any{
    return this.intialAssociatedModules;
  }
  getDefaultModule(): any{
    return this.defaultModule;
  }
  setDefaultModule(defaultModule): any{
    this.defaultModule = defaultModule;
  }
}
